(function () {

	if (!Array.from) {
		Array.from = (function () {
			var toStr = Object.prototype.toString;
			var isCallable = function (fn) {
				return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
			};
			var toInteger = function (value) {
				var number = Number(value);
				if (isNaN(number)) { return 0; }
				if (number === 0 || !isFinite(number)) { return number; }
				return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
			};
			var maxSafeInteger = Math.pow(2, 53) - 1;
			var toLength = function (value) {
				var len = toInteger(value);
				return Math.min(Math.max(len, 0), maxSafeInteger);
			};

    // La propriété length de la méthode vaut 1.
    return function from(arrayLike/*, mapFn, thisArg */) {
      // 1. Soit C, la valeur this
      var C = this;

      // 2. Soit items le ToObject(arrayLike).
      var items = Object(arrayLike);

      // 3. ReturnIfAbrupt(items).
      if (arrayLike == null) {
      	throw new TypeError("Array.from doit utiliser un objet semblable à un tableau - null ou undefined ne peuvent pas être utilisés");
      }

      // 4. Si mapfn est undefined, le mapping sera false.
      var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
      var T;
      if (typeof mapFn !== 'undefined') {
        // 5. sinon
        // 5. a. si IsCallable(mapfn) est false, on lève une TypeError.
        if (!isCallable(mapFn)) {
        	throw new TypeError('Array.from: lorsqu il est utilisé le deuxième argument doit être une fonction');
        }

        // 5. b. si thisArg a été fourni, T sera thisArg ; sinon T sera undefined.
        if (arguments.length > 2) {
        	T = arguments[2];
        }
    }

      // 10. Soit lenValue pour Get(items, "length").
      // 11. Soit len pour ToLength(lenValue).
      var len = toLength(items.length);

      // 13. Si IsConstructor(C) vaut true, alors
      // 13. a. Soit A le résultat de l'appel à la méthode interne [[Construct]] avec une liste en argument qui contient l'élément len.
      // 14. a. Sinon, soit A le résultat de ArrayCreate(len).
      var A = isCallable(C) ? Object(new C(len)) : new Array(len);

      // 16. Soit k égal à 0.
      var k = 0;  // 17. On répète tant que k < len…
      var kValue;
      while (k < len) {
      	kValue = items[k];
      	if (mapFn) {
      		A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
      	} else {
      		A[k] = kValue;
      	}
      	k += 1;
      }
      // 18. Soit putStatus égal à Put(A, "length", len, true).
      A.length = len;  // 20. On renvoie A.
      return A;
  };
}());
	}

	if (!Array.prototype.filter)
	{
		Array.prototype.filter = function(fun /*, thisArg */)
		{
			'use strict';

			if (this === void 0 || this === null) {
				throw new TypeError();
			}

			var t = Object(this);
			var len = t.length >>> 0;

    // NOTE : fix to avoid very long loop on negative length value

    if (len > t.length || typeof fun != 'function') {
    	throw new TypeError();
    }

    var res = [];
    var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
    for (var i = 0; i < len; i++)
    {
    	if (i in t)
    	{
    		var val = t[i];

        // NOTE: Techniquement on devrait utiliser Object.defineProperty
        //       pour le prochain index car push peut être affecté
        //       par les propriétés d'Object.prototype et d'Array.prototype.
        //       Cependant cette méthode est récente et les cas de collisions
        //       devraient rester rares : on préfère donc l'alternative la plus
        //       compatible.
        if (fun.call(thisArg, val, i, t))
        	res.push(val);
    }
}

return res;
};
}


let i;
	//RESIZE SCREEN
	let starter   = 1.4;

	//SLIDER PHOTO
	let slidePhoto   = document.querySelectorAll('.slider-photo-content div'),
	amountPhoto  = slidePhoto.length,
	startPhoto   = slidePhoto[0],
	counterPhoto = 0,
	triggerPhoto = document.querySelector('.slider-photo-content .trigger'),
	intervalSlidePhoto,
	timerPhoto   = 6000;

	//TEXTAREA RESIZE
	let textarea = document.querySelector('textarea');

	/* http://crocodillon.com/blog/non-blocking-web-fonts-using-localstorage */
	function localStorageFont (window, document) {
		'use strict';


		var isModernBrowser = (
			'querySelector' in document &&
			'localStorage' in window &&
			'addEventListener' in window
			),
		md5 = '762d1bf52788ff18986df8b69b3ced6f',
		key = 'fonts',
		cache;

		if (!isModernBrowser) {
			return;
		}

		var insertFont = function (value) {
			var style = document.createElement('style');
			style.innerHTML = value;
			document.head.appendChild(style);
		};

	    //PRE RENDER
	    try {
	    	cache = window.localStorage.getItem(key);
	    	if (cache) {
	    		cache = JSON.parse(cache);
	    		if (cache.md5 == md5) {
	    			insertFont(cache.value);
	    		} else {
	    			window.localStorage.removeItem(key);
	    			cache = null;
	    		}
	    	}
	    } catch (e) {
	    	return;
	    }

	    //POST RENDER
	    if (!cache) {
	    	window.addEventListener('load', function () {
	    		var request = new XMLHttpRequest(),
	    		response;
	    		request.open('GET', '/wp-content/themes/cubzaguais/css/font/droid_serif/droid_serif.json', true);
	    		request.onload = function () {
	    			if (this.status == 200) {
	    				try {
	    					response = JSON.parse(this.response);
	    					insertFont(response.value);
	    					window.localStorage.setItem(key, this.response);
	    				} catch(e) {
	                      // LocalStorage is probably full
	                  }
	              }
	          };
	          request.send();
	      });
	    }
	};

	localStorageFont(window, document);


	//EVENT LISTNER FUNCTIONS

	//OPEN MENUS
	let openNavigation = (el) => {
		let btn = document.querySelector('.open-main-nav');
		if (el.nextElementSibling.classList.contains('menu-part')) {
			el.nextElementSibling.classList.add('trigger')
			btn.classList.add('hide')
			document.body.classList.add('overflow-y-hidden')
		}
	}

	let closeNavigation = (el) => {
		let btn = document.querySelector('.open-main-nav');
		if (el.parentElement.parentElement.classList.contains('trigger')) {
			el.parentElement.parentElement.classList.remove('trigger')
			btn.classList.remove('hide')
			document.body.classList.remove('overflow-y-hidden')
		}
	}

	let toggleSubNavigation = (el) => {
		el.classList.toggle('trigger')
		el.nextElementSibling.classList.toggle('trigger')
	}

	let openMainNav = (el) => {
		el.classList.toggle('trigger')
		el.nextElementSibling.classList.toggle('trigger')
	}

	// //RESIZE SCREEN UP
	// let upSizeScreen = (starter) => {
	// 	starter = starter + .2;
	// 	document.body.style.fontSize = starter + 'em';
	// }
	// //RESIZE SCREEN DOWN
	// let decreaseSizeScreen = (starter) => {
	// 	starter = starter - .2;
	// 	document.body.style.fontSize = starter + 'em';
	// }

	function resizeScreenFontSize () {
		if (!document.querySelector('.resize-option'))
			return;

		let starter = 1.4;

		document.querySelector('.resize-option .less').addEventListener('click', function () {
			if (starter > 1.2) {
				starter = starter - .2;
				document.body.style.fontSize = starter + 'em';
			}
		});
		document.querySelector('.resize-option .more').addEventListener('click', function () {
			if (starter < 1.8) {
				starter = starter + .2;
				document.body.style.fontSize = starter + 'em';
			}
		});
	}

	resizeScreenFontSize()

	//PRINT PAGE
	let print = () => {
		window.print()
	}

	//TIMELINE
	let timelineContent = (content, index) => {
		for (i=0; i<content.length; i++) {

			if (i != index && content[i].classList.contains('trigger'))
				content[i].classList.remove('trigger')

			if (i == index && !content[i].classList.contains('trigger'))
				content[i].classList.add(('trigger'))
		}
	}

	let timelineDate = (e, element, content) => {
		let el       = e.target,
		children = el.parentElement.parentElement.children,
		previous = [],
		next     = [];

		for (i=0; i<element.length; i++) {

			if (el.parentElement.children == element[i].children) {

				let index = i;

				for (i=0; i<children.length; i++) {
					if (children[i].classList.contains('current') && children[i] != el)
						children[i].classList.remove('current')

					if (children[i].classList.contains('trigger') && children[i] != el)
						children[i].classList.remove('trigger')
				}

				el.parentElement.classList.add('current');

				let elParent = el.parentElement;

				while (elParent.previousElementSibling) {
					previous.push(elParent = elParent.previousElementSibling)
				}

				if (previous.length != 0) {
					for (i=0; i<previous.length; i++)
						previous[i].classList.add('trigger')
				}

				timelineContent(content, index)
			}
		}
	}

	let timelineEvent = () => {
		if (!document.querySelector('.timeline-date'))
			return;

		let timeline = document.querySelector('.timeline-date'),
		element  = document.querySelectorAll('.timeline-date li'),
		content  = document.querySelectorAll('.excerpt-of-timeline');

		timeline.addEventListener('click', (e) => {
			timelineDate(e, element, content);
		})
	}

	timelineEvent();

	let countTimeline = 0,
	translateTimeline = 0;

	let timelineAction = (el, boolean) => {
		let timelineContent = (boolean) ? el.previousElementSibling : el.nextElementSibling;

		if (!timelineContent.classList.contains('slider-timeline'))
			return

		let blockList = document.querySelector('.slider-list-timeline'),
		element   = document.querySelectorAll('.slider-list-timeline > li');


		if (boolean && countTimeline < (element.length - 4)) {
			translateTimeline = translateTimeline - 25;
			blockList.style.transform = ('translateX(' + translateTimeline + '%)')
			countTimeline++
		}
		if (!boolean && countTimeline != 0) {
			translateTimeline = translateTimeline + 25;
			blockList.style.transform = ('translate(' + translateTimeline + '%)')
			countTimeline--
		}
	}

	//TAB CONTENT
	let tabEvent = (el) => {
		let element = document.querySelectorAll('.tab-trigger'),
		li      = document.querySelectorAll('.tab-list li'),
		content = document.querySelectorAll('.tab-content');

		for (i=0; i<element.length; i++) {

			let index;

			if (el == element[i] && !el.parentElement.classList.contains('trigger')) {
				index = i;

				for (i=0; i<li.length; i++) {
					if (el != li[i].children && li[i].classList.contains('trigger'))
						li[i].classList.remove('trigger')
				}

				el.parentElement.classList.add('trigger')

				for (i=0; i<content.length; i++) {

					if (i == index && !content[i].classList.contains('trigger'))
						content[i].classList.add('trigger')

					if (i != index && content[i].classList.contains('trigger'))
						content[i].classList.remove('trigger')
				}
			}
		}
	}

	//REMOVE TRIGGER
	let removeTrigger = (target) => {
		if (target.classList.contains('trigger'))
			target.classList.remove('trigger')
	}

	//ACCORDEON
	let accordeonEvent = (el) => {
		el.nextElementSibling.classList.toggle('trigger')
	}

	//SLIDER PHOTO
	let slidingPhoto = (direction) => {
		triggerPhoto.setAttribute('aria-expanded', 'false');
		triggerPhoto.setAttribute('aria-hidden', 'true');
		triggerPhoto.classList.remove('trigger');
		counterPhoto = counterPhoto + direction;

		if (direction == -1 && counterPhoto < 0)
			counterPhoto = amountPhoto - 1;
		if (direction == 1 && !slidePhoto[counterPhoto])
			counterPhoto = 0;

		triggerPhoto = slidePhoto[counterPhoto]
		triggerPhoto.setAttribute('aria-expanded', 'true');
		triggerPhoto.setAttribute('aria-hidden', 'false');
		triggerPhoto.classList.add('trigger')
	}

	let autoSlidingPhoto = () => {
		triggerPhoto.setAttribute('aria-expanded', 'false');
		triggerPhoto.setAttribute('aria-hidden', 'true');
		triggerPhoto.classList.remove('trigger');
		counterPhoto = counterPhoto + 1;

		if (!slidePhoto[counterPhoto])
			counterPhoto = 0;

		triggerPhoto = slidePhoto[counterPhoto];
		triggerPhoto.classList.add('trigger');
		triggerPhoto.setAttribute('aria-expanded', 'true');
		triggerPhoto.setAttribute('aria-hidden', 'false');
	}

	function unwind () {
		intervalSlidePhoto = setInterval(autoSlidingPhoto, timerPhoto)
	}

	if (document.querySelector('.slider-photo-content'))
		unwind()

	//TEXTAREA RESIZE
	let autosize = function () {
		let el = this;

		setTimeout( function () {
			el.style.cssText = 'height: auto;';
			el.style.cssText = 'height:' + el.scrollHeight + 'px';
		}, 0)
	}

	if (textarea)
		textarea.addEventListener('keydown', autosize)

	//INPUT RADIO VALIDATION
	let inputRadioValidation = (el) => {
		let label = el.parentElement.parentElement.children;

		for (i=0; i<label.length; i++) {
			if (el != label[i] && label[i].classList.contains('trigger'))
				label[i].classList.remove('trigger')
		}

		if (!el.parentElement.classList.contains('trigger'))
			el.parentElement.classList.add('trigger')
		el.parentElement.parentElement.classList.remove('trigger')
		el.parentElement.parentElement.previousElementSibling.setAttribute('value', el.value)
	}

	//ON CONTACT FORM 7
	let inputAction = (index, target, element, box) => {
		let parentEl 	 = element[index].parentElement,
		parentTarget = target.parentElement,
		boxPrev 	 = box.previousElementSibling;

		let siblings = Array
		.from(parentEl.parentElement.parentElement.children)
		.filter(x => x != parentEl)

		for (i=0; i<siblings.length; i++) {
			let child = siblings[i].children[0]

			if (parentTarget != child && child.classList.contains('trigger'))
				child.classList.remove('trigger')
		}

		if (!parentEl.classList.contains('trigger'))
			parentEl.classList.add('trigger')

		box.classList.remove('trigger')
		if (boxPrev == document.querySelector('.open-dropdown'))
			boxPrev.setAttribute('value', element[index].value)
	}

	let inputRadioValidationCF7 = () => {
		let box   = document.querySelector('.contact-form-radio.dropdown-option'),
		input = document.querySelectorAll('.contact-form-radio input[type=radio]');

		box.addEventListener('click', (e) => {
			let el = e.target;

			for (i=0; i<input.length; i++) {
				let index = i;
				if (el == input[i])
					inputAction(index, el, input, box)
			}
		});
	}
	if (document.querySelector('.contact-form-radio'))
		inputRadioValidationCF7()

	//DROPDOWN OPEN
	let openDropdown = (el) => {
		let box = document.querySelectorAll('.dropdown-option');
		for (i=0; i<box.length; i++) {
			if (box[i].classList.contains('trigger') && box[i].previousElementSibling != el)
				box[i].classList.remove('trigger')
		}
		el.classList.toggle('trigger')
		el.nextElementSibling.classList.toggle('trigger')
	}

	//MAP SVG
	let drawInfoBox = () => {
		let map       = document.querySelector('.map-interactiv > svg > g'),
		content   = document.querySelectorAll('.map-content-zone'),
		container = document.querySelector('.map-interactiv-container');

		if (!map)
			return

		map.addEventListener('click', (e) => {
			let el = e.target.parentElement;

			if (!el.classList.contains('map-interactiv-zone'))
				return

			let data = el.getAttribute('data-map')

			for ( i=0; i<content.length; i++) {
				if (data != content[i].getAttribute('data-map'))
					continue;

				let contentSelected = content[i];

				if (!contentSelected.classList.contains('trigger')) {
					contentSelected.classList.add('trigger')
					container.classList.add('trigger')
				}
			}

		})
	}
	drawInfoBox()

	let closeMapSVG = (el) => {
		el.parentElement.classList.remove('trigger')
		document.querySelector('.map-interactiv-container').classList.remove('trigger')
	}

	// ANCHOR
	let anchorNavigation = (el) => {
		let siblings = Array
		.from(el.parentElement.parentElement.children)
		.filter(x => x != el)

		for (i=0; i<siblings.length; i++)
			removeTrigger(siblings[i])

		el.parentElement.classList.add('trigger')
	}

	//Filtre Tab Association
	let filterTab = (el) => {
		let button  = document.querySelectorAll('.filter-tab-button'),
		content = document.querySelectorAll('.filter-tab-content');

		for (i=0; i<button.length; i++) {

			let index;

			if (button[i] != el && button[i].classList.contains('trigger')) {
				button[i].classList.remove('trigger')
				index = i;

				for (i=0; i<content.length; i++) {
					if (index != i && content[i].classList.contains('trigger'))
						content[i].classList.remove('trigger')
					if (index == i && !content[i].classList.contains('trigger'))
						content[i].classList.add('trigger')
				}
			}
		}

		el.classList.add('trigger')
	}

	//EVENT
	document.body.addEventListener('click', (e) => {
		let el = e.target;

		if (el.classList.contains('print'))
			print()

		if (el.classList.contains('tab-trigger'))
			tabEvent(el)

		if (el.classList.contains('trigger-accordeon'))
			accordeonEvent(el)

		if (el == document.querySelector('.slider-photo-container .prev'))
			slidingPhoto(-1)

		if (el == document.querySelector('.slider-photo-container .next'))
			slidingPhoto(1)

		if (el.classList.contains('open-dropdown'))
			openDropdown(el)

		if (el.classList.contains('option'))
			inputRadioValidation(el)

		if (el.classList.contains('open-nav'))
			openNavigation(el)

		if (el.classList.contains('close-menu'))
			closeNavigation(el)

		if (el.classList.contains('open-sub-menu'))
			toggleSubNavigation(el)

		if (el == document.querySelector('.timeline-date .next'))
			timelineAction(el, true)

		if (el == document.querySelector('.timeline-date .prev'))
			timelineAction(el, false)

		if (el.classList.contains('close-infobox'))
			closeMapSVG(el)

		if (el.classList.contains('open-main-nav'))
			openMainNav(el)

		if (el.parentElement.classList.contains('anchor-link'))
			anchorNavigation(el);

		if (el.classList.contains('filter-tab-button'))
			filterTab(el);

		if (el.classList.contains('open-share'))
			document.querySelector('.share').classList.toggle('trigger');
	})

	//masonry
	let pushElement = function (targets, nb, num) {
		deleteElement(num);
		controlContainer(nb, num);
		for (i = 0; i < nb; i++) {
			let content = "";
			for (let n = i; n < targets.length; n += nb) {
				content = content + targets[n].outerHTML;
			};
			document.querySelectorAll('.masonry-container')[num].querySelectorAll('ul')[i].innerHTML = content;
		};
	};

	let controlContainer = function(nb, num) {
		let len = document.querySelectorAll('.masonry-container')[num].querySelectorAll('ul').length;
		if(len < nb){
			while(len < nb){
				let	container = document.createElement('ul');
				document.querySelectorAll('.masonry-container')[num].appendChild(container);
				len += 1;
			}
			return
		}
		if(len > nb){
			let containers = document.querySelectorAll('.masonry-container')[num].querySelectorAll('ul');
			i = 0;
			while(len > nb){
				containers[len-i-1].outerHTML = "";
				len -= 1;
			}
			return
		}
	}

	let deleteElement = function(num) {
		let targets = document.querySelectorAll('.masonry-container')[num].querySelectorAll('ul li')
		targets.forEach(function(target){
			target.outerHTML = "";
		})
	}

	if(document.querySelector('.masonry-container') != undefined){
		//var
		let  breakpointMd = 560,
			breakpointXl = 1050,
			nbCol = 3,
			buffer = [],
			targets = [],
			containers = document.querySelectorAll('.masonry-container'),
			width = window.innerWidth || document.documentElement.clientWidth,
			flagWidth = 'sm';

		if(document.querySelector('.masonry-container').classList.contains('grid-4')){
			nbCol = 4;
		}

		//init masonry
		for (var n = 0; n < containers.length; n++) {
			buffer.push([]);
			targets.push(containers[n].querySelectorAll('ul li'));
			for (i = 0; i < targets[n].length; i++) {
				buffer[n].push(targets[n][i].cloneNode(true)); //Deep copy
			};
			if (width >= breakpointMd && width < breakpointXl) {
				flagWidth = 'md';
				pushElement(buffer[n], 2, n);
			};
			if (width > breakpointXl){
				flagWidth = 'xl';
				pushElement(buffer[n], nbCol, n);
			};
		}

		window.addEventListener("resize", function () {
			let width = window.innerWidth || document.documentElement.clientWidth;
			if (width < breakpointMd) {
				if(flagWidth != 'sm'){
					for (var n = 0; n < containers.length; n++){
						pushElement(buffer[n], 1, n);
					}
				}
				flagWidth = 'sm';
			};
			if (width >= breakpointMd && width < breakpointXl) {
				if(flagWidth != 'md'){
					for (var n = 0; n < containers.length; n++){
						pushElement(buffer[n], 2, n);
					}
				}
				flagWidth = 'md';
			};
			if (width > breakpointXl){
				if(flagWidth != 'xl'){
					for (var n = 0; n < containers.length; n++){
						pushElement(buffer[n], nbCol, n);
					}
				}
				flagWidth = 'xl';
			};
		});
	}


	let triggerSize = true;

		let masonryInit = () => {
			let initer = document.querySelectorAll('.masonry-event');

			for (let b=0; b<initer.length; b++) {
				let container = initer[b],
				li = container.querySelectorAll('li');

				for (i=0; i<2; i++) {
					let ul = document.createElement('ul');
					container.appendChild(ul)
				}

				let ul = container.querySelectorAll('ul');

				for (let k=0; k<ul.length; k++) {
					for (i=k; i<li.length; i = i+3)
						ul[k].appendChild(li[i])
				}

				triggerSize = false
			}
		}

		function resizeMasonryDesktop () {
			let initer = document.querySelectorAll('.masonry-event');

			for (let b=0; b<initer.length; b++) {
				let container = document.querySelectorAll('.masonry-event')[b],
				li = container.querySelectorAll('li'),
				ul = container.querySelectorAll('ul')

				if (ul.length < 2) {
					for (i=0; i<2; i++) {
						let ulNew = document.createElement('ul');
						container.appendChild(ulNew)
					}
					ul = container.querySelectorAll('ul')
				}

				for (let k=0; k<ul.length; k++) {
					for (i=k; i<li.length; i = i+3)
						ul[k].appendChild(li[i])
				}
			}
		}

		function resizeMasonryMobile () {
			let initer = document.querySelectorAll('.masonry-event');

			for (let b=0; b<initer.length; b++) {
				triggerSize = true;

				let container = document.querySelectorAll('.masonry-event')[b],
				ul = container.querySelectorAll('ul'),
				length = ul[0].querySelectorAll('li').length,
				newUl = [];

				for (let k=0; k<length; k++) {
					for (i=0; i<ul.length; i++) {
						let li = ul[i].querySelectorAll('li')[k]

						if (li == undefined)
							break;

						newUl.push(li)
					}
				}

				for (i=0; i<newUl.length; i++)
					ul[0].appendChild(newUl[i])
			}
		}

		masonryInit();

		if (document.querySelector('.masonry-event')) {
			if (window.innerWidth >= 560)
				masonryInit();
			if (window.innerWidth >= 560 && triggerSize) {
				resizeMasonryDesktop()
				triggerSize = false
			}
			else if (window.innerWidth < 560 && !triggerSize) {
				resizeMasonryMobile()
			}

			window.onresize = function () {
				if (window.innerWidth >= 560)
					masonryInit();
				if (window.innerWidth >= 560 && triggerSize) {
					resizeMasonryDesktop()
					triggerSize = false
				}
				else if (window.innerWidth < 560 && !triggerSize) {
					resizeMasonryMobile()
				}
			}
		}

	let assoSize = true;

	let assoInit = () => {
		let container = document.querySelector('.asso-masonry'),
		li = container.querySelectorAll('li');

		if (container.querySelectorAll('ul').length < 2)
			container.appendChild(document.createElement('ul'))

		let ul = container.querySelectorAll('ul')

		for (let k=0; k<ul.length; k++) {
			for (i=k; i<li.length; i = i+2)
				ul[k].appendChild(li[i])
		}

		assoSize = false
	}

	function assoMobile() {
		assoSize = true

		let container = document.querySelector('.asso-masonry'),
		ul = container.querySelectorAll('ul'),
		length = ul[0].querySelectorAll('li').length,
		newUl = []

		for (let k=0; k<length; k++) {
			for (i=0; i<ul.length; i++) {
				let li = ul[i].querySelectorAll('li')[k]

				if (li == undefined)
					break;

				newUl.push(li)
			}
		}

		for (i=0; i<newUl.length; i++)
			ul[0].appendChild(newUl[i])
	}

	if (document.querySelector('.asso-masonry')) {
		if (window.innerWidth >= 560)
			assoInit();

		window.onresize = function () {
			if (window.innerWidth >= 560 && assoSize) {
				assoInit()
				assoSize = false
			}
			else if (window.innerWidth < 560 && !assoSize) {
				assoMobile()
			}
		}
	}

	function toggleTrigger (element) {
		element.classList.toggle('trigger');
	}

	function initMenuFixed() {
		let anchor = document.querySelector('.anchor-menu');

		if (document.body.clientWidth >= 1450) {
			let headerHeight = document.querySelector('#menu').clientHeight;

			if (window.scrollY >= headerHeight)
				toggleTrigger(anchor)
		}
	}

	initMenuFixed()

	window.addEventListener('scroll', function () {
		let clientWidth = document.body.clientWidth,
		headerHeight = document.querySelector('#menu').clientHeight,
		scrollY = this.scrollY,
		anchor = document.querySelector('.anchor-menu')

		if (clientWidth >= 1450 && scrollY >= headerHeight && !anchor.classList.contains('trigger'))
			anchor.classList.add('trigger')
		else if (clientWidth >= 1450 && scrollY < headerHeight && anchor.classList.contains('trigger'))
			anchor.classList.remove('trigger')
	})

})();
